import { FC } from 'react';
import { TbPlus } from 'react-icons/tb';

import { Button, ButtonProps } from '@mantine/core';

import { useCurrentUser } from 'hooks/use-current-user';
import { ProjectService } from 'services/ProjectService';
import { UserService } from 'services/UserService';

const ProjectCreateButton: FC<{ label?: string; size?: ButtonProps['size'] }> = ({ label, size }) => {
    const user = useCurrentUser();
    const currentTeam = user?.team;

    const redirectToCreate = async (team?: string) => {
        if (team && team !== currentTeam) {
            await UserService.switchTeam(team);
        }

        await ProjectService.navigate.create();
    };

    return (
        <Button
            onClick={() => redirectToCreate()}
            variant="filled"
            size={size}
            leftSection={<TbPlus size={14} strokeWidth={1.25} />}
        >
            {label || 'Create New Project'}
        </Button>
    );
};

export { ProjectCreateButton };
